import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const PreviousLocationContext = createContext();

export const PreviousLocationProvider = ({ children }) => {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(() => {
    return sessionStorage.getItem('previousPath') || null;
  });

  useEffect(() => {
    const currentPath = location.pathname;
    const storedCurrent = sessionStorage.getItem('currentPath');

    if (storedCurrent !== currentPath) {
      sessionStorage.setItem('previousPath', storedCurrent || '');
      sessionStorage.setItem('currentPath', currentPath);
      setPreviousPath(storedCurrent);
    }
  }, [location.pathname]);

  return (
    <PreviousLocationContext.Provider value={{ previousPath }}>
      {children}
    </PreviousLocationContext.Provider>
  );
};

export const usePreviousLocation = () => useContext(PreviousLocationContext);
